import React from 'react';
import AppLayout from '../components/AppLayout';
import SencoCohortDataPanel from '../components/dashboard/SencoCohortDataPanel';
import SchoolPageHeader from '../components/school/SchoolPageHeader';
import { Icons } from '../lib/Icons';

export default function SencoCohortDataPage() {
  return (
    <AppLayout>
      <div className="max-w-7xl mx-auto space-y-6">
        <SchoolPageHeader
          title="Cohort Data"
          description="EHCP counts, attainment by year group, and subject breakdowns."
          icon={Icons.ChartBar}
          breadcrumbs={[
            { label: 'Dashboard', href: '/dashboard' },
            { label: 'Cohort Data' },
          ]}
        />
        <div className="rounded-2xl border border-gray-100 bg-white shadow-sm p-5">
          <SencoCohortDataPanel embedded />
        </div>
      </div>
    </AppLayout>
  );
}
